/*
 * GTM Source Types
 */

//#region  Home Page (HP)

export const HP = {
  PAGE: 'HP',
  HERO: 'HP-Hero',
  POPULAR: 'HP-Popular',
  HIGHLIGHTED: 'HP-Topic',
  LATEST: 'HP-Latest',
  EDITOR: 'HP-Editor',
  CAROUSEL: 'HP-NewVideo',
  VIDEO: 'HP-NewVideo',
  ADDITIONAL: 'HP-Additional',
  POINT_OF_VIEW: 'HP-PointOfView',
  MORE: 'HP-More',
  LOCATION_SEO: 'HP-LocationSEO',
  DEVELOPER_SEO: 'HP-DeveloperSEO',
  PROJECT_SEO: 'HP-ProjectSEO',
  SEGMENT_SEO: 'HP-SegmentSEO',
};

//#endregion

//#region LANDING PAGE (LP)

export const LANDING_PAGE_SOURCE = {
  HP: 'HP',
  CONDO: 'CDO',
  HOME: 'HM',
  TOWN_HOME: 'TWH',
  VACATION: 'GOV',
  HOME_OFFICE: 'HMO',
  MIX_USED: 'MCK',
  COMMERCIAL: 'CMD',
};

//#endregion

//#region Search Results Page (SRP)

export const SRP = {
  PAGE: 'SRP',
  MORE: 'SRP-More',
  LOCATION_SEO: 'SRP-LocationSEO',
  DEVELOPER_SEO: 'SRP-DeveloperSEO',
  PROJECT_SEO: 'SRP-ProjectSEO',
  SEGMENT_SEO: 'SRP-SegmentSEO',
};

//#endregion

//#region Article Details Page (ADP)

export const ADP = {
  PAGE: 'ADP',
  RECOMMENDED: 'ADP-Recommended',
  MORE: 'ADP-More',
  GALLERY: 'ADP-Gallery',
  OTHER_ARTICLE: 'ADP-OtherArticles',
};

//#endregion

//#region Project Page (PP)

export const PP = {
  PAGE: 'PP',
};

//#endregion

//#region Tag Page (TP)

export const TP = {
  PAGE: 'TP',
};

//#endregion

//#region Other Pages (Other)

export const OTHER = {
  PAGE: 'Other',
};

//#endregion
